import React from 'react';
import moment from 'moment';

import Modal from 'cccisd-modal';
import { Formik, Form, Field, CccisdSelect, CccisdDatepicker } from 'cccisd-formik';
import axios from 'cccisd-axios';
import Button from 'cccisd-click-button';

import IconEdit from 'cccisd-icons/pencil';
import IconInfo from 'cccisd-icons/info2';

const Boilerplate = window.cccisd.boilerplate;
const Fortress = window.cccisd.fortress;

async function handleSubmit({ pawnId, pawnHash, values, closeModal, loadData }) {
    await axios.put(
        Boilerplate.route('api.nexus.pawn.update', {
            pawn: pawnId,
        }),
        {
            pawnHash,
            caregiverConsent: values.caregiverConsent,
            caregiverConsentDateReceived:
                values.caregiverConsent !== null ? values.caregiverConsentDateReceived : null,
        }
    );

    closeModal && closeModal();
    loadData && loadData();
}

export default function CaregiverConsentModal({
    loadData,
    row: {
        'pawn.pawnId': pawnId,
        'pawn.pawnHash': pawnHash,
        caregiverConsent,
        'fields.caregiverConsentDateReceived': caregiverConsentDateReceived,
    },
}) {
    const labelType = getLabelType();

    function getLabelType() {
        if (caregiverConsent === '0') {
            return 'danger';
        }
        if (caregiverConsent === '1') {
            return 'success';
        }
        return 'default';
    }

    function getStatusString() {
        if (caregiverConsent === '1') {
            return `Yes - ${
                caregiverConsentDateReceived
                    ? moment(caregiverConsentDateReceived).format('MM/DD/YYYY')
                    : 'No date provided'
            }`;
        }
        if (caregiverConsent === '0') {
            return `No - ${
                caregiverConsentDateReceived
                    ? moment(caregiverConsentDateReceived).format('MM/DD/YYYY')
                    : 'No date provided'
            }`;
        }
        if (caregiverConsent === 'NA') {
            return 'Not yet received';
        }
    }

    return Fortress.user.acting.role.handle === 'orgAdmin' ? (
        <Modal
            title="Caregiver Consent"
            trigger={
                <button type="button" className={`btn btn-xs btn-${labelType}`}>
                    <strong>
                        <IconEdit spaceRight />
                        {getStatusString()}
                    </strong>
                </button>
            }
            render={({ closeModal }) => {
                return (
                    <Formik
                        onSubmit={values =>
                            handleSubmit({ pawnId, pawnHash, values, closeModal, loadData })
                        }
                        initialValues={{ caregiverConsent, caregiverConsentDateReceived }}
                    >
                        {({ values, isSubmitting, submitForm }) => (
                            <Form>
                                <section>
                                    <article className="alert alert-info" role="alert">
                                        <IconInfo spaceRight />
                                        <strong>Heads up!</strong>
                                        <span>
                                            {' '}
                                            For the 2020/2021 school year, the DePaul team will
                                            enter Caregiver Consent data.
                                        </span>
                                    </article>
                                </section>
                                <section>
                                    <Field
                                        component={CccisdSelect}
                                        name="caregiverConsent"
                                        label="Caregiver Consent Decision"
                                        options={[
                                            { label: 'Yes', value: '1' },
                                            { label: 'No', value: '0' },
                                            { label: 'Not yet received', value: 'NA' },
                                        ]}
                                    />
                                    {values.caregiverConsent !== 'NA' && (
                                        <Field
                                            component={CccisdDatepicker}
                                            name="caregiverConsentDateReceived"
                                            label="Date Consent Decision was Received"
                                            placeholder="MM/DD/YYYY"
                                        />
                                    )}
                                </section>
                                <section
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginTop: '1em',
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-link"
                                        onClick={() => closeModal()}
                                    >
                                        Cancel
                                    </button>
                                    <Button
                                        title="Submit"
                                        type="submit"
                                        isLoading={isSubmitting}
                                        className="btn btn-primary"
                                        onClick={() => submitForm()}
                                    />
                                </section>
                            </Form>
                        )}
                    </Formik>
                );
            }}
        />
    ) : (
        <span className={`label label-${labelType}`}>{getStatusString()}</span>
    );
}
